export * from '@primeuix/themes/nora/tabs';
export { default } from '@primeuix/themes/nora/tabs';
